export default {
  "b2b.autocompletes.doplnkove-sluzby.label": "Additional service",
  "b2b.autocompletes.doplnkove-sluzby.label-multiple": "Additional services",
  "b2b.autocompletes.doplnkove-sluzby.placeholder": "Select additional service",
  "b2b.autocompletes.doplnkove-sluzby.placeholder-multiple":
    "Select additional services",
  "b2b.autocompletes.zakaznici.label": "Customer",
  "b2b.autocompletes.zakaznici.placeholder": "Select customer",
  "b2b.autocompletes.uzivatele.label": "User",
  "b2b.autocompletes.uzivatele.placeholder": "Select user",
  "b2b.autocompletes.projekty.label": "Project",
  "b2b.autocompletes.projekty.placeholder": "Select project",
  "b2b.autocompletes.produkty.label": "Product",
  "b2b.autocompletes.produkty.label-multiple": "Products",
  "b2b.autocompletes.produkty.placeholder": "Select product",
  "b2b.autocompletes.produkty.placeholder-multiple": "Select products",
  "b2b.autocompletes.smlouvy.label": "Contract",
  "b2b.autocompletes.smlouvy.placeholder": "Select contract",
  "b2b.autocompletes.zdroj.label": "Resource",
  "b2b.autocompletes.zdroj.placeholder": "Select source",
  "b2b.autocompletes.zadosti-stav.label": "Request status",
  "b2b.autocompletes.zadosti-stav.placeholder": "Select request status"
};
